'use strict';

import { Platform } from 'react-native';
import { AsyncStorage } from 'utils/Community';
import CommonBridge from 'common/CommonBridge';
import Constants from 'common/Constants';
import { BSLInit, BSLAppInterface } from '../bsl/core';
import { request } from '../services/request';
// import AuthUtil from '../utils/AuthUtil';
// import RNContent from './RNContent';

const AppRequest = {
  async fetchData(url, data, showLogin, resultIsJson, isOrigin) {
    return await request.fetchData(url, data, showLogin, resultIsJson, isOrigin);
  },

  async fetchJsonp(url) {
    return await request.fetchJsonp(url);
  },

  getHeaders() {
    return request.getHeaders();
  },
};

const AppStorage = {
  async setItem(name, value) {
    try {
      await AsyncStorage.setItem(name, value);
    } catch (error) {}
  },

  async getItem(name) {
    try {
      return await AsyncStorage.getItem(name);
    } catch (error) {
      return null;
    }
  },
};

const AppCookie = {
  async setCookie(domain, name, value) {},

  async getCookie(domain, name) {},

  async clearCookie(domain) {},
};

const AppAuth = {
  async isLogined() {
    // return AuthUtil.isLogined();
  },

  async getUserId() {
    return Constants.UserId;
  },

  async getUserIcon() {
    return null;
  },
};

const AppNotify = {
  bslEventHandler: [],
  onDataChanged(eventname, data, pageId) {
    const arr = this.bslEventHandler;
    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        // console.log('onDataChanged:', eventname, pageId, arr[i].id);

        if (arr[i].id && arr[i].id != pageId) {
          continue;
        }

        const callback = arr[i].cb;
        callback && callback(eventname, data, pageId);
      }
    }
  },

  gotoLogin() {},

  showVerifyUI(params, callback) {},
  registerEvent(callback, subId) {
    if (__DEV__) {
      const arr = this.bslEventHandler;
      for (let i = 0; i < arr.length; i++) {
        if (callback == arr[i].cb) {
          console.warn('registerEvent() registed same event.');
        }
      }
    }

    if (callback) {
      this.bslEventHandler.push({ cb: callback, id: subId });
    }
  },

  unRegisterEvent(callback) {
    const arr = this.bslEventHandler;
    if (arr && arr.length > 0) {
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].cb == callback) {
          arr.splice(i, 1);
        }
      }
    }
  },

  unRegisterPageEvent(subId) {
    if (subId == null || subId == undefined) {
      return;
    }

    const arr = this.bslEventHandler;
    if (arr && arr.length > 0) {
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].id == subId) {
          arr.splice(i, 1);
        }
      }
    }
  },
};

const AppInfo = {
  getBslPlat() {
    if (CommonBridge.isWeb()) {
      return 'M';
    } else {
      return 'RN';
    }
  },

  getAppPlat() {
    return Platform.OS;
  },
  async asyncGetEnvMode() {
    return await CommonBridge.getEnvStatus();
  },
  isStagingMode() {
    if (!CommonBridge.isWeb()) {
      return CommonBridge.isStaging();
    } else {
      return CommonBridge.isStaging();
    }
  },

  getChannel() {
    return Constants.source;
  },

  getAppName() {
    return CommonBridge.AppKey;
  },
};

function CreateBSLInterface() {
  const appInterface = new BSLAppInterface();
  appInterface.setRequest(AppRequest);
  appInterface.setCookie(AppCookie);
  appInterface.setAuth(AppAuth);
  appInterface.setNotify(AppNotify);
  appInterface.setStorage(AppStorage);
  appInterface.setAppInfo(AppInfo);
  if (CommonBridge.isWeb()) {
    const host = {
      host: location.origin,
      devHost: location.origin,
    };
    host.getHost = (isDev) => {
      return location.origin;
    };
    host.getTradeHost = () => {
      return location.origin;
    };
    appInterface.setHost(host);
  } else if (CommonBridge.isMishop()) {
    const host = {
      host: 'https://trade-api.retail.mi.com',
      devHost: 'http://test-trade-api.retail.mi.com',
      preHost: 'http://pre-trade-api.retail.mi.com',
    };
    host.getHost = (isDev) => {
      return isDev ? host.devHost : host.host;
    };
    host.getTradeHost = () => {
      return undefined;
    };
    appInterface.setHost(host);
    // CommonBridge.i
  }

  BSLInit(appInterface);
  return appInterface;
}

function registerBSLEvent(callback, subId) {
  callback && AppNotify.registerEvent(callback, subId);
}

function unRegisterBSLEvent(callback) {
  AppNotify.unRegisterEvent(callback);
}

function unRegisterBSLPageEvent(pageId) {
  AppNotify.unRegisterPageEvent(pageId);
}

export { CreateBSLInterface, registerBSLEvent, unRegisterBSLEvent, unRegisterBSLPageEvent };
